import React, { useEffect, useState,useRef  } from "react"
import { apiEndpoint } from "helpers/url_helper";

import MetaTags from 'react-meta-tags';
import Select from "react-select";
import moment from "moment";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    Container,
    ButtonGroup,
    UncontrolledTooltip,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    ButtonDropdown,
    CardTitle,
    CardHeader,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import ReactToPrint from "react-to-print";
const { SearchBar } = Search;
import ReactBSAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import * as XLSX from 'xlsx';


//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
//import ModalInFunctionalComponent from '../../components/Logs/ViewImageModal';
import { SpeedType } from './VehicleCountComponents';
// import { ReportType, SpeedType } from './VehicleCountComponents';

import paginationFactory from 'react-bootstrap-table2-paginator';
import MaxSpeedChart from "./MaxSpeedChart";
import DiskChart from "./DiskChartSpeedDistribution";
import DiskChartBK from "./DiskChartBkup";
import VehicleCount from "./VehicleCntAreachart";
import AvgSpeedChart from "./AvgSpeedChart.js"
import AreaChart from "./areachart.js";
//Style
const btnstylesObj = {
    "margin-top": '2rem',
  };

 // This is  custom csv export component
const ExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
        <Button  size="sm" id="csv-tooltip"
        className="buttons-copy buttons-html5"
        color="dark" onClick={ handleClick }>
        <span>Csv</span></Button>
    );
  };

  const ReportType = (props) => {
    const ReportTypeitems = [
      {
        value: 1,
        label: "Daily"
      },
      {
        value: 2,
        label: "Weekly"
      },
      {
        value: 3,
        label: "Monthly"
      },
    //   {
    //     value:4,
    //     label:"Custom"
    //   }
    ];
    // 👇️ initial value of empty string (first option)
    const [SelectedReportTypeitem, setSelectedReportTypeItem] = useState({ value: 1, label: "Daily" });
    const [FromDtTm, setFrmDttm] = useState(moment().format("YYYY-MM-DD 00:00"));
    const [ToDtTm, setToDttm] = useState(moment().format("YYYY-MM-DD HH:mm"));
    const handleReportTypeChange = event => {
      //console.log('Label 👉️', event.label);
      console.log(event);
      setSelectedReportTypeItem(event);
      props.setReportType(event.value);
      const startTime = document.getElementById('from-datetime-local-input');
      const endTime = document.getElementById('to-datetime-local-input');
      var now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      endTime.value = now.toISOString().slice(0,16);
      switch(event.value){
      case 1:
           var d=new Date();

          d.setHours(0, 0, 0, 0)
          d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
          startTime.value=d.toISOString().slice(0,16)
        endTime.value = now.toISOString().slice(0,16);

        fromDateChange(d.toISOString().slice(0,16))
        toDateChange(now.toISOString().slice(0,16))
        break;
        case 2:
        var d = new Date();

         d.setDate(d.getDate() - 7);
        // Zero the time component
         d.setHours(0, 0, 0, 0);
         d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
         var oneMonthAgo = d.toISOString();
         document.getElementById('from-datetime-local-input').value=oneMonthAgo.slice(0,16)
         d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
         endTime.value = now.toISOString().slice(0,16);
         fromDateChange(oneMonthAgo.slice(0,16))
         toDateChange(now.toISOString().slice(0,16))
         break;
          case 3:
          var d = new Date();

         d.setMonth(d.getMonth() - 1);
         d.setHours(0, 0, 0, 0);
         d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
           var oneMonthAgo = d.toISOString();
            document.getElementById('from-datetime-local-input').value=oneMonthAgo.slice(0,16)
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
            endTime.value = now.toISOString().slice(0,16);

            fromDateChange(oneMonthAgo.slice(0,16))
       toDateChange(now.toISOString().slice(0,16))
            break;
            case 4:
          break;
     }
    };
    const fromDateChange=(value)=>{
      setFrmDttm(value)
      console.log(SelectedReportTypeitem)
  }
  const toDateChange=(value)=>{
  setToDttm(value)
  }
    return (
      <Select  inputProps={{ id: 'ReportType' }}  value={SelectedReportTypeitem}  options={ReportTypeitems} onChange={handleReportTypeChange}></Select>
    );
  };


const ViolationTables = (props) => {
    //Print function
    const componentRef = useRef();
    const [Campusitems, setCampusItems] = useState([]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState();

    const [FromDtTm, setFrmDttm] = useState(moment().format("YYYY-MM-DD 00:00"));
    const [ToDtTm, setToDttm] = useState(moment().format("YYYY-MM-DD HH:mm"));

    const [FromSpeed, setFrmSpeed] = useState(20);
    const [ToSpeed, setToSpeed] = useState(100);
    const [BoolANPR, setANPR] = useState(true);



    useEffect(() => {
        // UserValidated
        fetch(apiEndpoint+"/GetLogCampusList",
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  "strToken": sessionStorage.getItem("Clear_AuthUser")
                  
                })
              })   
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined){
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken));
                    //console.log(result);
                    console.log(JSON.parse(result.CampusList));
                    setCampusItems(JSON.parse(result.CampusList));
                    var campuslst = JSON.parse(result.CampusList);
                    setSelectedCampusItem(campuslst[0]);
                    setCampusSelected(campuslst[0].value);
                    changeCampusSelectHandler(campuslst[0]);
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
    }, [])

    const [Locitems, setLocItems] = useState([]);
    const [SelectedLocitem, setSelectedLocItem] = useState([]);
    const [selectedLocVal, setLocSelected] = useState();


    useEffect(() => {
        debugger;
        // UserValidated
        fetch(apiEndpoint+"/GetLogLocationList",
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  "strToken": sessionStorage.getItem("Clear_AuthUser"),
                  "intCampusID": selectedCampusVal
                  
                })
              })  
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined)
                    {
                       debugger;
                       //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                    if(result.Locations!=undefined){
                        debugger;
                        console.log(JSON.parse(result.Locations));
                    setLocItems(JSON.parse(result.Locations));
                    var loclst = JSON.parse(result.Locations);
                    if(loclst != null){
                        console.log("Location List on vehicle count"+loclst);
                        setSelectedLocItem(loclst[0]);
                        setLocSelected(loclst[0].value);
                        
                        changeLocSelectHandler(loclst[0]);
                    }
                    

                
                    }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
    }, [selectedCampusVal])

    const changeCampusSelectHandler = (event) => {
        setSelectedCampusItem(event);
        setCampusSelected(event.value);
    };

    const changeLocSelectHandler = (event) => {
        debugger;
        setSelectedLocItem(event);
        setLocSelected(event.value);
    };

    const changeFrmSpeedHandler= (value, ctx) => {
        if(value>parseInt(ToSpeed)){
            return "Enter Valid From Speed Value!!";
          }
          return true;
    }

    const changeToSpeedHandler = (value, ctx) => {
        if(value<parseInt(FromSpeed)){
          return "Enter Valid To Speed Value!!";
        }
        return true;
      }
   
      const changeFrmDateHandler= (value, ctx) => {
      //  console.log(value);
        if(value>ToDtTm){
            return "From date cannot be greater than To date!!!";
          }
          return true;

    }

const fromDateChange=(value)=>{
    setFrmDttm(value)
switch(selectedReportTypeVal){
    case 1:
        var d=new Date(value);
        d.setDate(d.getDate() + 1);
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
        document.getElementById('to-datetime-local-input').value=d.toISOString().slice(0,16)
        break;
        case 2:
            var d=new Date(value);
            d.setDate(d.getDate() + 7);
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
            document.getElementById('to-datetime-local-input').value=d.toISOString().slice(0,16)
            break;
            case 3:
            var d=new Date(value);
            d.setMonth(d.getMonth() + 1);
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
            document.getElementById('to-datetime-local-input').value=d.toISOString().slice(0,16)
                break;
                case 4:
                    break;
}
}
const toDateChange=(value)=>{
setToDttm(value)
switch(selectedReportTypeVal){
    case 1:
        var d=new Date(value);
        d.setDate(d.getDate() - 1);
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
        document.getElementById('from-datetime-local-input').value=d.toISOString().slice(0,16)
        break;
        case 2:
            var d=new Date(value);
            d.setDate(d.getDate() - 7);
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
            document.getElementById('from-datetime-local-input').value=d.toISOString().slice(0,16)
            break;
            case 3:
            var d=new Date(value);
            d.setMonth(d.getMonth() - 1);
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
            document.getElementById('from-datetime-local-input').value=d.toISOString().slice(0,16)
                break;
                case 4:
                    break;
}
}
    const changeToDateHandler = (value, ctx) => {
        if(value<FromDtTm){
          return "To date cannot be lesser than From date!!!";
        }
        return true;
      }
    const [selectedReportTypeVal, setReportType] = useState(1);
    const [selectedSpeedTypeVal, setSpeedType] = useState(1);


    const breadcrumbItems = [
        // { title: "Lexa", link: "#" },
        // { title: "Tables", link: "#" },
        // { title: "Editable Table", link: "#" },
    ]
    const [violations, setViolations] = useState([]);
    const [alertmsg, setAlert] = useState([]);
    const [requestBody, setrequestbody] = useState();
    const SearchViolations = () => {

   var requestB=JSON.stringify({
    "intCampusID": selectedCampusVal,
    "intLocationID": selectedLocVal,
    "intReportType": selectedReportTypeVal,
    "FromDtTm": document.getElementById('from-datetime-local-input').value,
    "ToDtTm": document.getElementById('to-datetime-local-input').value,
    "intSpeedType": selectedSpeedTypeVal,
    "FromSpeed": FromSpeed,
    "ToSpeed": ToSpeed,
})
      setrequestbody(requestB);

    }
    const Search = () => {

    if(
        document.getElementById('to-datetime-local-input').value < document.getElementById('from-datetime-local-input').value){
alert("Start date can not be greater than end date!")
        }
        else{
SearchViolations()
        }}
    useEffect(() => {
        props.setBreadcrumbItems('Vehicle Count', breadcrumbItems)
        SearchViolations()
    })

    const handleDownload = () => {
        debugger;
        // const fetchAvgSpeed = fetch(apiEndpoint + "/GetAvgSpeedData", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({
        //         "intCampusID": selectedCampusVal,
        //         "intLocationID": selectedLocVal,
        //         "intReportType": selectedReportTypeVal,
        //         "FromDtTm": document.getElementById('from-datetime-local-input').value,
        //         "ToDtTm": document.getElementById('to-datetime-local-input').value,
        //         "intSpeedType": selectedSpeedTypeVal,
        //         "FromSpeed": FromSpeed,
        //         "ToSpeed": ToSpeed
        //     })
        // });

        // const fetchMaxSpeed = fetch(apiEndpoint + "/VehicleCountGetMaxSpeedData", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({
        //         "intCampusID": selectedCampusVal,
        //         "intLocationID": selectedLocVal,
        //         "intReportType": selectedReportTypeVal,
        //         "FromDtTm": document.getElementById('from-datetime-local-input').value,
        //         "ToDtTm": document.getElementById('to-datetime-local-input').value,
        //         "intSpeedType": selectedSpeedTypeVal,
        //         "FromSpeed": FromSpeed,
        //         "ToSpeed": ToSpeed
        //     })
        // });
         
        // const fetchVehicleCount = fetch(apiEndpoint + "/GetVehicleCountDetails", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({
        //         "intCampusID": selectedCampusVal,
        //         "intLocationID": selectedLocVal,
        //         "intReportType": selectedReportTypeVal,
        //         "FromDtTm": document.getElementById('from-datetime-local-input').value,
        //         "ToDtTm": document.getElementById('to-datetime-local-input').value,
        //         "intSpeedType": selectedSpeedTypeVal,
        //         "FromSpeed": FromSpeed,
        //         "ToSpeed": ToSpeed
        //     })
        // });

        // Promise.all([fetchAvgSpeed, fetchMaxSpeed,fetchVehicleCount])
        // .then(responses => Promise.all(responses.map(response => response.json())))
        // .then(
        //     ([avgSpeedResult, maxSpeedResult,vehicleCountResult]) => {
        //         const parsedAvgSpeed = JSON.parse(avgSpeedResult.avgSpeed);
        //         const parsedMaxSpeed = JSON.parse(maxSpeedResult.maxSpeed);
        //         const parsedVehicleCount = JSON.parse(vehicleCountResult.VehicleCount);

        //         console.log('parsedAvgSpeed', parsedAvgSpeed);
        //         console.log('parsedMaxSpeed', parsedMaxSpeed);
        //         console.log('parsedVehicleCount', parsedVehicleCount);
                
        //         // Combine data from all three sources
        //         const combinedData = parsedAvgSpeed.map(avgSpeedItem => {
        //             const maxSpeedItem = parsedMaxSpeed.find(maxSpeedItem => maxSpeedItem.Key === avgSpeedItem.Key);
        //             const vehicleCountItem = parsedVehicleCount.find(vehicleCountItem => vehicleCountItem.Key === avgSpeedItem.Key);
                
        //             // Ensure that the Key property exists in avgSpeedItem
        //             if (avgSpeedItem.Key) {
        //                 return {
        //                     incidentTime: avgSpeedItem.Key,
        //                     avgSpeed: avgSpeedItem.avgSpeed,
        //                     maxSpeed: maxSpeedItem ? maxSpeedItem.maxSpeed : null,
        //                     vehicleCount: vehicleCountItem ? vehicleCountItem.vehicleCount : null
        //                 };
        //             } else {
        //                 console.error('Key property is missing in avgSpeedItem:', avgSpeedItem);
        //                 return null; // Handle the case where Key is missing
        //             }
        //         }).filter(item => item !== null); // Remove items with missing Key
                
        //         // Console log for debugging combinedData

        //         console.log("combinedData", combinedData);

        //         // Create a new workbook
        //         const wb = XLSX.utils.book_new();

        //         // Add the sheet with combined data
        //         const wsCombinedData = XLSX.utils.json_to_sheet(combinedData);
        //         XLSX.utils.book_append_sheet(wb, wsCombinedData, 'CombinedData');

        //         // Save the workbook to a file
        //         XLSX.writeFile(wb, 'data.xlsx');
           
              
        //     },
        //     // Handle errors here
        //     (error) => {
        //         console.error('Error fetching data:', error);
        //         // Handle the error here
        //     }
        // );

        // can't change
        fetch(apiEndpoint+"/GetVehicleCountDetails",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "intCampusID": selectedCampusVal,
    "intLocationID": selectedLocVal,
    "intReportType": selectedReportTypeVal,
    "FromDtTm": document.getElementById('from-datetime-local-input').value,
    "ToDtTm": document.getElementById('to-datetime-local-input').value,
    "intSpeedType": selectedSpeedTypeVal,
    "FromSpeed": FromSpeed,
    "ToSpeed": ToSpeed
             })
        })
        .then(res => res.json())
        .then(
            (result) => {
                debugger;
                 const parsedData = JSON.parse(result.VehicleCount);
                console.log("parsedData", parsedData);
                const formattedData = parsedData.map(item => ({
                    ...item,
                    IncidentTime: new Date(item.IncidentTime).toLocaleString().replace('T', ' '), // Replace 'T' with space
                    AverageSpeed: item.AverageSpeed.toFixed(2)
                }));
    
                console.log("formattedData", formattedData);

                const ws = XLSX.utils.json_to_sheet(formattedData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'VehicleCountDetails');
                const fileName = 'VehicleCount'+new Date().toLocaleDateString()+'.xlsx';
                XLSX.writeFile(wb, fileName);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                //setError(error);
            }
        )


       
    
       
      };


    console.log(requestBody)
    return (

        <React.Fragment>

            <MetaTags>
                <title>Indus | Vehicle Count</title>
            </MetaTags>
            <AvForm className="needs-validation">
            <Row>
                <Col md={2}>
                    <label className="mt-1" > Campus  </label>
                    <Select value={SelectedCampusitem} options={Campusitems} onChange={changeCampusSelectHandler}></Select>
                </Col>
                <Col md={2}>
                    <label className="mt-1" > Location  </label>
                    <Select value={SelectedLocitem} options={Locitems} onChange={changeLocSelectHandler}></Select>

                    {/* <Select value={SelectedLocitem} options={Locitems} onChange={changeLocSelectHandler}></Select> */}
                </Col>
                <Col md={2}>

<label className="mt-1" > Statistics Type  </label>
<ReportType setReportType={setReportType}></ReportType>
</Col>


<Col sm={3} className="customdttm" style={{ display: "block" }}>
                    <label className="form-label mt-1"> From  </label>
                    <input
                    name="frmdttm"
                        type="datetime-local"
                        validate={{myValidation: changeFrmDateHandler}}
                        className="form-control"
                    defaultValue={FromDtTm}
                        id="from-datetime-local-input"
                        //onChange={handleChange}
                     onChange={(event) =>fromDateChange(event.target.value)}
                      />
                    {/* <input className="form-control" type="datetime-local" defaultValue={FromDtTm}
                        id="from-datetime-local-input"
                        onChange={(event) => setFrmDttm(event.target.value)} /> */}
                </Col>
                <Col sm={3} className="customdttm" style={{ display: "block" }}>

                    <label className="form-label mt-1" > To  </label>
                    <input
                    name="todttm"
                        type="datetime-local"
                        validate={{myValidation: changeToDateHandler}}
                        className="form-control"
                        defaultValue={ToDtTm}
                        id="to-datetime-local-input"
                        onChange={(event) =>toDateChange(event.target.value)}
                      />
                    {/* <input className="form-control" type="datetime-local" defaultValue={ToDtTm}
                        id="to-datetime-local-input" onChange={(event) => setToDttm(event.target.value)} /> */}
                </Col>
                


            </Row>          <br></br>
            <Row>

            <Col md={2}>
                    <label className="mt-1" > Speed Range  </label>
                    <SpeedType setSpeedType={setSpeedType}></SpeedType>
                </Col>
                <Col md={2} className="customspeed" style={{ display: "none" }}>
                    <label className="form-label mt-1"> From  </label>
                    <AvField
                        name="fromspeed"
                        placeholder="From Speed"
                        type="number"
                        errorMessage="Enter From Speed Value"
                        validate={{myValidation: changeFrmSpeedHandler}}
                        className="form-control"
                        defaultValue={FromSpeed}
                        id="from-speed"
                        onChange={(event) => setFrmSpeed(event.target.value)}
                      />
                </Col>
                <Col md={2} className="customspeed" style={{ display: "none" }}>
                    <label className="form-label mt-1"> To  </label>
                    <AvField
                        name="tospeed"
                        placeholder="To Speed"
                        type="number"
                        errorMessage="Enter To Speed Value"
                        validate={{myValidation: changeToSpeedHandler}}
                        className="form-control"
                        defaultValue={ToSpeed}
                        id="from-speed"
                        onChange={(event) => setToSpeed(event.target.value)}
                        />
                </Col>
            <Col md={2} >
            <Link className="btn btn-primary waves-effect waves-light" style={btnstylesObj}
                        to="#" role="Button" onClick={handleDownload} >Average Speed Report</Link>
                </Col>

            </Row>
            </AvForm>
            <br></br>
            <Row className="mt-3">
                <Col>
                    <Card >

                        <CardBody>
                       <h4>Maximum Speed  </h4>
                      <MaxSpeedChart props={requestBody}></MaxSpeedChart>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <Card >

                        <CardBody>
                        <h4>Average Speed  </h4>
                        <AvgSpeedChart props={requestBody}></AvgSpeedChart>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
<Row>
    <Col lg={6}>
    <Card >

                       <CardBody>
        <h4>Speed Distribution</h4>
        <DiskChartBK props={requestBody}></DiskChartBK>
        </CardBody>
                    </Card>

    </Col>
    <Col lg={6}>
    <Card >

                       <CardBody>
        <h4>Vehicle Count</h4>
        <VehicleCount props={requestBody}></VehicleCount>
        </CardBody>
                    </Card>
    </Col>
</Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(ViolationTables);
